module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/file.4c89fe9e.svg";